import PARENT from '../types';

const PRIMARY_PARAMETER = `${PARENT}/PRIMARY_PARAMETER`;

export const SET_PRIMARY_PARAMETER = `${PRIMARY_PARAMETER}/SET`;

export default PRIMARY_PARAMETER;
